'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BACKSPACE = exports.BACKSPACE = 8;
var BRACKET_LEFT = exports.BRACKET_LEFT = 219;
var BRACKET_RIGHT = exports.BRACKET_RIGHT = 221;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var TAB = exports.TAB = 9;
var ESC = exports.ESC = 27;
var LEFT = exports.LEFT = 37;
var NBSP = exports.NBSP = 160;
var RIGHT = exports.RIGHT = 39;
var SPACE = exports.SPACE = 32;
var UP = exports.UP = 38;
var Y = exports.Y = 89;
var Z = exports.Z = 90;
var NUMBER_0 = exports.NUMBER_0 = 48;
var NUMBER_1 = exports.NUMBER_1 = 49;
var NUMBER_2 = exports.NUMBER_2 = 50;
var NUMBER_3 = exports.NUMBER_3 = 51;
var NUMBER_4 = exports.NUMBER_4 = 52;
var NUMBER_5 = exports.NUMBER_5 = 53;
var NUMBER_6 = exports.NUMBER_6 = 54;
var NUMBER_7 = exports.NUMBER_7 = 55;
var NUMBER_8 = exports.NUMBER_8 = 56;
var NUMBER_9 = exports.NUMBER_9 = 57;
var KEYPAD_NUMBER_0 = exports.KEYPAD_NUMBER_0 = 96;
var KEYPAD_NUMBER_1 = exports.KEYPAD_NUMBER_1 = 97;
var KEYPAD_NUMBER_2 = exports.KEYPAD_NUMBER_2 = 98;
var KEYPAD_NUMBER_3 = exports.KEYPAD_NUMBER_3 = 99;
var KEYPAD_NUMBER_4 = exports.KEYPAD_NUMBER_4 = 100;
var KEYPAD_NUMBER_5 = exports.KEYPAD_NUMBER_5 = 101;
var KEYPAD_NUMBER_6 = exports.KEYPAD_NUMBER_6 = 102;
var KEYPAD_NUMBER_7 = exports.KEYPAD_NUMBER_7 = 103;
var KEYPAD_NUMBER_8 = exports.KEYPAD_NUMBER_8 = 104;
var KEYPAD_NUMBER_9 = exports.KEYPAD_NUMBER_9 = 105;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/constants/KeyCodes.js
// module id = 471
// module chunks = 2 3